/**
 * Global Scope JS
 *  - will load shared script on every page
 */
import { SlideToggleContainer } from "./modules/components/SlideToggleContainer";
import { FocusGuard } from "./modules/components/FocusGuard";
import A11y from "./modules/base/Accessibility";
import AnimationCore from "./modules/animations/Core";
import Components from "./modules/base/Components";
import isMobile from "ismobilejs";
import LazyLoad from "vanilla-lazyload";
import FBCoversionsApi from './modules/base/FbConversionsApi';
import Alpine from 'alpinejs'
import { register } from 'swiper/element/bundle';
register();
import CircleType from 'circletype';
window.CircleType = CircleType;

window.Alpine = Alpine;
Alpine.data('Header', Header);
Alpine.bind('SlideToggleContainer', SlideToggleContainer);
Alpine.bind('FocusGuard', FocusGuard);
Alpine.store('menuDesktopOpen', false);
Alpine.store('menuLanguageSwitcherOpen', false);
Alpine.store('menuSearchOpen', false);
Alpine.store('menuMobileOpen', false);

/** Set up window object */
window.Zero = window.Zero || {};
window.Zero.scroll = window.Zero.scroll || {};
window.Zero.scroll.direction = window.Zero.scroll.direction || {};

/** Let's start loading our images */
window.Zero.lazyLoad = new LazyLoad({
	threshold: 600,
	callback_enter: (ev) => {
		// read data attr, fire animation class
	}
});

/** Set base config */
window.Zero.a11y = new A11y();
window.Zero.animation = new AnimationCore({
	threshold: 0.3
});
window.Zero.components = new Components();
window.Zero.events = {};
window.Zero.isMobile = isMobile(window.navigator).any;
window.Zero.isPhone = isMobile(window.navigator).phone
window.Zero.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

window.Zero.fbConversionsApi = new FBCoversionsApi();

/** Hopefull don't need this anymore */
// const ua = navigator.userAgent || navigator.vendor || window.opera;
// const isInstagram = (ua.indexOf("Instagram") > -1) ? true : false;

// if(isInstagram){
// 	document.body.className += " instagram-browser force-mobile";
// }

/** Grab the rest of our scripts */
import "./modules/base/Listeners";
import { Header } from "./modules/components/Header";

// Alpine.start();
